import { styled } from '@mui/system';

export const HeaderWrapper = styled('div')(() => ({
  fontSize: 24,
  flex: 1,
  marginBottom: 20,
  alignItems: 'center',
}));
